"use client";

import {
  QueryClientProvider,
  QueryClient,
  QueryCache,
} from "@tanstack/react-query";
import { useState } from "react";
import { Provider as JotaiProvider, useAtom } from "jotai";
// import { AxiosError } from "axios";
import { isSignedInAtom } from "@/hooks/authAtoms";
import { PagesPaths } from "./functions/pages-paths";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { deleteTokens } from "./functions/cookieOperations";

function Providers({ children }: React.PropsWithChildren) {
  const [, setSignedIn] = useAtom(isSignedInAtom);
  const router = useRouter();
  const [client] = useState(
    // new QueryClient({ defaultOptions: { queries: { staleTime: Infinity } } })
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error: any) => {
            // console.log("errorrrrrrrrrr", error);
            // if (["ERR_NETWORK"].includes(error.code!)) setNoInternet(true);
            // if (error?.response?.status === 406) {
            //   router.replace("/");
            //   setNoInternet(true);
            // }
            // if (["ERR_BAD_REQUEST"].includes(error.code)) router.reload();
            if (error?.response?.status === 401) {
              deleteTokens();
              // if (err.response?.config?.url === "/users/refresh-token" || err.config?.url === "/users/refresh-token")
              setSignedIn(false);
              router.replace(PagesPaths.signin);
            }
          },
        }),
        defaultOptions: {
          queries: {
            cacheTime: Infinity,
            staleTime: Infinity,
            refetchOnReconnect: true,
            // retry: (failureCount, error: AxiosError) => {
            //   // if (error.response?.status === 406) {
            //   //   router.replace("/");
            //   //   setShowVerify(true);
            //   // }
            //   if (error.response?.status === 401) return true;
            //   return error.response?.status === 406 || failureCount > 3 ? false : true;
            // },
          },
        },
      }),
  );

  return (
    <JotaiProvider>
      <QueryClientProvider client={client}>
        {children}
      </QueryClientProvider>
    </JotaiProvider>
  );
}

export default Providers;
